import React, {useEffect, useState, useContext} from  'react';
import {useParams, useHistory} from 'react-router-dom';

import './updateizvestaj.styles.css'

import Input from '../../utils/input/Input'
import {VALIDATOR_REQUIRE} from '../../utils/input/validators';
import {useForm} from '../../utils/input/form-hook';
import LoadingSpinner from '../../utils/loader/LoadingSpinner';
import {useHttpClient} from '../../utils/input/http-hook';
import {AuthContext} from '../../utils/context/auth-context';

// const IZVESTAJI = [
//     { id : '1', naslov: 'raj na rajcu', opis:'aaaaaaaaa ssssssssssssss dddddddddddd', datum: '2020-02-14', 
//     image:
//       'https://images.pexels.com/photos/839011/pexels-photo-839011.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',},
//     { id : '2', naziv: 'rudnik', opis:'ccccccccccc hhhhhhhhhhhhh jjjjjjjjjj', datum: '01/10/2019', 
//     image:
//       'https://images.pexels.com/photos/839011/pexels-photo-839011.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',},
//     { id : '3', naziv: 'despotovim stazama', opis:'bbbbbbbbbb nnnnnnnnnnnnnnnn mmmmmmmm', datum: '22.01.2019', 
//     image:
//       'https://images.pexels.com/photos/839011/pexels-photo-839011.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',}

// ];




const UpdateIzvestaj = () => {

    const auth = useContext(AuthContext);  
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [loadedIzvestaj, setLoadedIzvestaj] = useState();   

    const id = useParams().id;
    const history = useHistory();

    const [formState, inputHandler, setFormData] = useForm(
        {
          naslov: {
            value: '',
            isValid: false
          },
          opis: {
            value: '',
            isValid: false
          },
          datum: {
            value: '',
            isValid: false
          }
        },
        false
      );    


    // const identifiedPlace = IZVESTAJI.find(p => p.id === id);

    useEffect(() => {
      const fetchIzvestaj = async () => {
        try {
          const responseData = await sendRequest(
            `${process.env.REACT_APP_BECKEND_URL}/izvestaji/${id}`
          );         
          setLoadedIzvestaj(responseData.izvestaj);         
          setFormData(
            {
              naslov: {
                value: responseData.izvestaj.naslov,
                isValid: true
              },
              opis: {
                value: responseData.izvestaj.opis,
                isValid: true
              },
              datum: {
                value: responseData.izvestaj.datum,
                isValid: true
              }
            },
            true
          );
  
        } catch (err) {}
      };
      fetchIzvestaj();
    }, [sendRequest, id, setFormData]);   


  const placeUpdateSubmitHandler = async event => {
    event.preventDefault();
    try {
      await sendRequest(
        `${process.env.REACT_APP_BECKEND_URL}/izvestaji/${id}`,
        'PATCH',
        JSON.stringify({
          naslov: formState.inputs.naslov.value,
          opis: formState.inputs.opis.value,
          datum: formState.inputs.datum.value

        }),
        {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth.token
        }
      );
      history.push('/izvestaji');
    } catch (err) {}
  };

  if (isLoading) {
    return (
      <div className="center-loader">
        <LoadingSpinner />  
      </div>
    );
  }


    if (!loadedIzvestaj && !error) {
        return (
          <div className="center-loader">            
              <LoadingSpinner />            
          </div>
        );
      }

    return(
     
       <section className="section-book">
       {!isLoading && loadedIzvestaj &&  <div className="row">
            <div className="book">
                <div className="book__form">
                <form className="form" onSubmit={placeUpdateSubmitHandler}>
                        <div className="u-margin-bottom-medium">
                            <h2 className="heading-secondary">
                                Update Izvestaj
                            </h2>
                        </div>
                        

                        <div className="form__group">
                            <Input 
                                id="naslov"
                                element="input" 
                                type="text"
                                label="Naslov" 
                                validators={[VALIDATOR_REQUIRE()]} 
                                // errorText="error"
                                onInput={inputHandler}
                                initialValue={loadedIzvestaj.naslov}
                                initialValid={true}
                             ></Input>                                   
                        </div>

                        <div className="form__group">
                        <Input 
                                id="datum"
                                element="input" 
                                type="date"
                                label="Datum" 
                                validators={[VALIDATOR_REQUIRE()]} 
                                // errorText="error"
                                onInput={inputHandler}
                                initialValue={loadedIzvestaj.datum}
                                initialValid={true}
                             ></Input>                                    
                        </div>

                        <div className="form__group">
                        <Input 
                                id="opis"
                                element="textarea" 
                                type="text"
                                label="Izvestaj" 
                                validators={[VALIDATOR_REQUIRE()]} 
                                rows="4"
                                // errorText="error"
                                onInput={inputHandler}
                                initialValue={loadedIzvestaj.opis}
                                initialValid={true}
                             ></Input>                                   
                        </div>

                        <div className="form__group">
                            <button className="btn btn--green" type="submit" disabled={!formState.isValid}>Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
      }
    </section>
      );
}



export default UpdateIzvestaj;